import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-curp-sexes',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-curp-sexes-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-curp-sexes-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-curp-sexes-index" */ '@/modules/configurations/catalogs/catalog-curp-sexes/views/Index.vue')
        }
    ]
}
